var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoftskills1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.9375C9 10.7629 10.7629 9 12.9375 9C15.1121 9 16.875 10.7629 16.875 12.9375C16.875 14.0251 16.4355 15.008 15.7217 15.7217C15.008 16.4355 14.0251 16.875 12.9375 16.875C10.7629 16.875 9 15.1121 9 12.9375Z",
    fill: "#22C55E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.625 0C6.54784 0 0 6.54784 0 14.625C0 22.7022 6.54784 29.25 14.625 29.25C22.7022 29.25 29.25 22.7022 29.25 14.625C29.25 6.54784 22.7022 0 14.625 0ZM12.9375 6.75C9.52024 6.75 6.75 9.52024 6.75 12.9375C6.75 16.3548 9.52024 19.125 12.9375 19.125C14.2392 19.125 15.4481 18.7222 16.4446 18.0356L19.4545 21.0455C19.8938 21.4848 20.6062 21.4848 21.0455 21.0455C21.4848 20.6062 21.4848 19.8938 21.0455 19.4545L18.0356 16.4446C18.7222 15.4481 19.125 14.2392 19.125 12.9375C19.125 9.52024 16.3548 6.75 12.9375 6.75Z",
    fill: "#22C55E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftskills1);
export default __webpack_public_path__ + "static/media/softskills1.f21420c13a018c8ff3f3470a67b0e1ea.svg";
export { ForwardRef as ReactComponent };